import {
    isSouthAfricaTenantValue,
    isSouthKoreaTenantValue,
    type Tenant,
} from '../configuration/tokenHandling/tokenSlice';

export const isFleetMonitorVisibleForTenant = (tenant?: Tenant) =>
    !isSouthAfricaTenantValue(tenant) && !isSouthKoreaTenantValue(tenant);
